import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

const Pending = () => {
    const location = useLocation()
    const [orderDetails, setOrderDetails] = useState()
    const [showErr, setShowErr] = useState(false)
    const [searchParams] = useSearchParams()
    const pollIntervalId = useRef()
    const [baseurl, setURL] = useState(window.location.origin)
    // const [baseurl, setURL] = useState('http://10.10.20.2:9900')
    const navigate = useNavigate()
    const pollInterval = 3000;
    const [redirectLinks, setRedirect] = useState()

    useEffect(() => {
        let upiObj = {};
        if (searchParams.size) {
            for (const entry of searchParams.entries()) {
                upiObj[entry[0]] = entry[1]
            }
            setOrderDetails((prev) => ({ ...prev, ...upiObj }))
        }
        // fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
        fetch(`${baseurl}/pay/transaction/merchant-urls-info?orderId=${upiObj.transactionId}`, { method: "POST" }).then(res => res.json()).then((res) => {
            if (res?.data == "Failed") {
                // window.open(location.state,"_self")
                setShowErr(true)
            } else {
                let obj = Object.entries(res?.data || {}).reduce((acc, [key, value]) => {
                    if (value) acc[key] = value;
                    return acc;
                }, {})
                
                setOrderDetails((prev) => ({ ...prev, ...obj }))
            }
        })
    }, [searchParams])


    useEffect(() => {
        if (orderDetails) {
            clearInterval(pollIntervalId?.current)
            pollIntervalId.current = setInterval(pollForStatus, pollInterval)
        }

    }, [orderDetails])

    async function pollForStatus() {
        if (orderDetails?.orderId) {
            
            try {
                // const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/pay/transaction/pollForStatus?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).catch((res) => { });
                const response = await fetch(`${baseurl}/pay/transaction/pollForStatus?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`, { method: 'GET' }).catch((res) => { });
                if (response.ok) {
                    const result = await response.json(); // Assuming JSON response
                    if (result.message === 'TIME_EXCEEDED') {
                        clearInterval(pollIntervalId.current)
                        navigate(`/timed-out?orderId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })

                    }
                    if (result.message === 'SUCCESS') { // Check success condition
                        clearInterval(pollIntervalId.current); // Stop polling
                        // clearInterval(countIntervalId.current); // Stop polling
                        navigate(`/success?orderId=${orderDetails?.orderId}&transactionId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.pendingRedirectionURL })
                    }
                    if (result.message === 'CANCELLED') { // Check success condition
                        clearInterval(pollIntervalId.current); // Stop polling
                        // clearInterval(countIntervalId.current); // Stop polling
                        navigate(`/cancel?orderId=${orderDetails?.transactionId}`, { replace: true, state: redirectLinks?.failedRedirectionURL })
                    }
                } else {

                }
            } catch (error) {
            }
        }
    }

    return <div className="main-box">
        <div className="pending-box">
            {!showErr && <><h4 className="title">Transaction Pending</h4>
                <p>Your transaction is currently under process. Please review the details below:</p>
                <div className="orderDetails">
                    <p>Order ID:{orderDetails?.orderId}</p>
                    <p>Transaction ID:{orderDetails?.transactionId}</p>
                </div>
                <button className="back-button" onClick={() => { window.open(orderDetails?.pendingRedirectionURL, "_self") }}>Back to home</button></>}
            {showErr && <>
                <h4 className="title text-danger">Order Record Not Found</h4></>}
        </div>
    </div>
}

export default Pending